(function () {
  'use strict';

  function initFaq(section) {
    if (!section || section.dataset.swanFaqInitialized === 'true') return;
    section.dataset.swanFaqInitialized = 'true';

    var search = section.querySelector('[data-swan-faq-search]');
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-swan-faq-category]'));
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-swan-faq-item]'));
    var count = section.querySelector('[data-swan-faq-count]');
    var empty = section.querySelector('[data-swan-faq-empty]');
    var activeCategory = 'all';

    function normalize(value) {
      return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function update() {
      var query = normalize(search && search.value);
      var visible = 0;

      items.forEach(function (item) {
        var categoryMatches = activeCategory === 'all' || item.getAttribute('data-category') === activeCategory;
        var searchMatches = !query || normalize(item.getAttribute('data-search-index')).indexOf(query) !== -1;
        var show = categoryMatches && searchMatches;
        item.hidden = !show;
        if (show) visible += 1;
      });

      if (count) count.textContent = visible + (visible === 1 ? ' answer' : ' answers');
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.getAttribute('data-swan-faq-category') || 'all';
        buttons.forEach(function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        update();
      });
    });

    if (search) search.addEventListener('input', update);

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (candidate) {
          if (candidate !== item && candidate.open && !candidate.hidden) candidate.open = false;
        });
      });
    });

    update();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-swan-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
